<template>
	<div class="container-fluid" id="coi-core-table-root" >
    <b-row>
      <b-col>
        <b-row id="coi-core-table-order-nr-row">
          <span><b>B-Nr.:&nbsp;</b></span>
          <copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">
            <!-- {{customerOrder.customerorderitems[0].id}} -->
            <b>{{customerOrder.id}}</b>
          </copy-to-clipboard-component>
          <span>
				&nbsp;
				&nbsp;
			</span>
          <div><!-- Umbestellung/Neubestellungs badges -->

            <h3>
              <b-badge v-if="customerOrder.isVendorChange" variant="success">Umbestellung</b-badge>
              <b-badge v-if="customerOrder.isReorder"      variant="success">Neubestellung</b-badge>
              <b-badge
                  v-if="customerOrder.new_deliveries.length > 0"
                  variant="danger"
                  class="badge-href-red"
                  @click="openInNewTab(`/customerorder/${customerOrder.new_deliveries[0].customerOrderIdNewDelivery }`)"
              >Hier geht 's zur Verlustsendung</b-badge>
              <b-badge
                  v-else-if="customerOrder.old_deliveries.length > 0"
                  variant="success"
                  class="badge-href-success"
                  @click="openInNewTab(`/customerorder/${customerOrder.old_deliveries[0].customerOrderId}`)"
              >Verlustsendung</b-badge>
              <b-badge v-else-if="customerOrder.isMarketplaceMultiorder" class="badge-orange">MP-Multiorder</b-badge>
            </h3>

          </div>
          <div> <!-- this div is necessary to keep the badges from expanding horzontally to fil the b-row. -->
            <h3>
              &nbsp;
              <span v-if     ="customerOrder.shippingType === SHIPPING_TYPE.REGISTERED"     class="badge badge-purple"><b>Einschreiben</b></span>
              <span v-else-if="customerOrder.shippingType === SHIPPING_TYPE.EXPRESS"        class="badge badge-yellow"><b>Expressversand</b></span>
              <span v-else-if="customerOrder.shippingType === SHIPPING_TYPE.SELLER_PRIME"   class="badge badge-yellow"><b>Seller 1-Day PRIME</b></span>
              <span v-else-if="customerOrder.shippingType === SHIPPING_TYPE.SELLER_PRIME_2" class="badge badge-yellow"><b>Seller 2-Day PRIME</b></span>
              <span v-else-if="customerOrder.shippingType === SHIPPING_TYPE.SELLER_PRIME_STD"      class="badge badge-yellow"><b>Seller Standard PRIME</b></span>
              <span v-else-if="customerOrder.shippingType === SHIPPING_TYPE.PRIORITY_PRIME"           class="badge badge-yellow"><b>Priority PRIME</b></span>
              <span v-else-if="customerOrder.shippingType === SHIPPING_TYPE.PRIORITY_NON_PRIME"      class="badge badge-yellow"><b>Priority NON-PRIME</b></span>
              <span v-else-if="customerOrder.shippingType === SHIPPING_TYPE.MARKET_FULFILLMENT"      class="badge badge-yellow"><b>FBA</b></span>
              <span v-else></span>
            </h3>
          </div>
        </b-row>

        <div class="row">
          <div class="col pl-0 mb-2">
            <img :src="sellerImageUrl" style="width: 150px" />
          </div>
        </div>
        <coi-core-table v-if="!userPreferenceStore.coi.lightMode" :customerOrder="this.customerOrder" small stacked borderless style="min-width:350px;" />
      </b-col>
      <b-col v-if="userPreferenceStore.coi.lightMode">
        <coi-core-table :customerOrder="this.customerOrder"/>
      </b-col>
    </b-row>
	</div>
</template>
<style scoped>
	.badge-href-red:hover {
		background-color:#f75f48 !important;
		 text-decoration: underline !important;
		cursor: pointer !important;
	}

	.badge-href-blue:hover {
		background-color:#6fb5ff !important;
		 text-decoration: underline !important;
		cursor: pointer !important;
	}

	.table-stack {
		white-space:nowrap;
	}
	.badge-purple {
		background-color:#CC33FF;
		color:white;
	}
	.badge-yellow {
		background-color:#ffe100;
		color:black;
	}
	.badge-orange {
		background-color: #fcb103;
		color: black;
	}
</style>
<script>
import { useUserPreferenceStore } from '../../stores/UserPreferenceStore';

export default {
  setup(){
    const userPreferenceStore = useUserPreferenceStore();
    return {userPreferenceStore}
  },
	props: ["customerOrder"],
	data() {
		return {
			sellerImageUrl: "",
            SHIPPING_TYPE: { // I really hate that the laravel models DO NOT TRANSFER this kind of data to our views.
                NORMAL: 0,
                REGISTERED: 1,
                EXPRESS: 2,
                MARKET_FULFILLMENT: 3,
                SELLER_PRIME: 4,
                SELLER_PRIME_2: 5,
                SELLER_PRIME_STD: 6,
                TRACKED: 7,
                PRIORITY_PRIME: 8,
                PRIORITY_NON_PRIME: 9
            }
		};
	},
	computed: {
	},
	watch: {
	},
	created()
	{

		/*
		if(!this.customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime ||  "" == this.customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime)
		{
			this.lastCancellationDate = this.customerOrder.lastCancellationDate;
		}else{
			this.meldedatum   = this.formatDate(this.customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime);
		}
		*/

		//get the curret account image url:

		if( 1000 < this.customerOrder.marketAccountId && this.customerOrder.marketAccountId < 2000 || this.customerOrder.marketAccountId == 11000) {
			this.sellerImageUrl = "/images/coseon.png";
		}else if( [2008, 12000].includes(this.customerOrder.marketAccountId) ){
			this.sellerImageUrl = "/images/wr.jpg";
		}else if(this.customerOrder.marketAccountId == 30) {
			this.sellerImageUrl = "/images/icons/ready4u.png"
		}else if( 3000 < this.customerOrder.marketAccountId && this.customerOrder.marketAccountId < 4000 || this.customerOrder.marketAccountId == 13000) {
			this.sellerImageUrl = "/images/lddmusic_logo.png"
		}else{
			this.sellerImageUrl = "/images/logo.png";
		}

	},
	methods: {
		openInNewTab(url) { var win = window.open(url, "_blank"); win.focus() }
	}
};
</script>
